module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_22",
      "title": "22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("CHAPTER 3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline-Chapter-dl"
  }, [_c('span', {
    staticClass: "Tw_Cen_MT_Regular_11"
  }, [_vm._v("CHARLOTTE")])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline-Chapter-dl-last"
  }, [_c('span', {
    staticClass: "Tw_Cen_MT_Regular_11"
  }, [_vm._v("THURSDAY, MARCH 3, 1949")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Salutation-lsa"
  }, [_c('span', {
    staticClass: "Typewriter_Elite_MT_Std_Regular_11"
  }, [_vm._v("Dear Miss Friedman,")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Body-Text-No-Indent-ltx1"
  }, [_c('span', {
    staticClass: "Typewriter_Elite_MT_Std_Regular_11"
  }, [_vm._v("We are pleased to inform you that you have been selected as a finalist for Miss Subways. Please report to the John Robert Powers Modeling Agency at 247 Park Avenue, New York City, on Monday, March 7, at 1:00 P.M. sharp for your interview. We are unable to reschedule this appointment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Closing-lcl"
  }, [_c('span', {
    staticClass: "Typewriter_Elite_MT_Std_Regular_11"
  }, [_vm._v("Sincerely yours,")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Signature-lsig-first"
  }, [_c('span', {
    staticClass: "Typewriter_Elite_MT_Std_Regular_11"
  }, [_vm._v("Diana Fontaine")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Signature-lsig"
  }, [_c('span', {
    staticClass: "Typewriter_Elite_MT_Std_Regular_11"
  }, [_vm._v("Director of Model Services")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Signature-lsig"
  }, [_c('span', {
    staticClass: "Typewriter_Elite_MT_Std_Regular_11"
  }, [_vm._v("John Robert Powers Modeling Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-Before--tx"
  }, [_vm._v("Charlotte had forgotten all about Sam’s cockamamie idea to enter her into the Miss Subways contest. Thinking back now on that night a group of them had been out for "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_23",
      "title": "23"
    }
  }, [_vm._v("ice cream, she remembered it was actually Martin who had raised the flag.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Say, what do you think of submitting Charlotte’s photograph for Miss Subways?” he had said to Sam and Charlotte while the others in their group heatedly debated the Dodgers’ prospects for the upcoming season.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You’re a regular Jack Benny!” Charlotte said. “I could never be chosen for Miss Subways.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well, sure you could, Charlotte,” Sam said. “You’re just as pretty—scratch that—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("prettier")]), _vm._v(" than any of the girls I’ve seen on those posters.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“My agency runs the whole program and my boss told me that they’re always looking for pretty girls. Let me enter you, Charlotte,” Martin said. “What’s the worst thing that could happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Whatever you say, Martin. As long as you get me an interview at your agency.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You can be sure of that, Charlotte. J. Walter Thompson would be lucky to have a girl like you in the typing pool.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Let’s just see what happens, they had said to her. Live a little, Charlotte. “Why not?” she had ultimately told them, trying, though it wasn’t easy, to be game and easygoing. Charlotte had been 99 percent certain that nothing would ever result from them entering her besides a curtly worded letter thanking her for her interest and sending her on her pleasant good-luck-ever-being-a-model way. Make that 100 percent.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But, she now realized, she was wrong. Something "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("had")]), _vm._v(" come of it. Charlotte laughed aloud at the cruel irony. Two letters in one day. The first denying her entr"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("e into the industry she so desperately wanted to be part of. The second inviting her to participate in one she couldn’t care less about. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_24",
      "title": "24"
    }
  }, [_vm._v("How she wished their contents had been switched. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yes, Miss Friedman, we’d love for you to type our memos and fetch our coffee. We’re terribly sorry, Miss Friedman, you’re not lovely enough to be featured in our subway beauty pageant.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte crumpled the letter at the inanity of it all.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Who was it from, Charlotte?” her mother called.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte returned to the kitchen and threw the balled-up letter into the garbage. “Miss Subways. Sam’s friend entered me. And they chose me as a finalist.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“How about that?” Mrs. Friedman met Charlotte’s eyes for the first time that day.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s ridiculous,” Charlotte said, waving her hand dismissively.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Your father would never allow it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Which is fine, because I would never do it. I have no time for silly things like Miss Subways. Speaking of having no time, I’m going to JoJo’s to study and then I’m meeting Sam for dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Miss Subways! That’s marvelous, Charlotte!” JoJo said when Charlotte told her. The girls were sitting on JoJo’s bed, their econ books and notes strewn across JoJo’s matelass"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Did you pinch a shot of your father’s whiskey again?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m serious. Miss Subways is a big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Maybe. For silly girls who have nothing better to do than fuss over their looks.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You do realize that you can be smart and serious and still fuss over your looks. It’s not a crime in this country.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I do realize that, but thank you for pointing it out,” "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_25",
      "title": "25"
    }
  }, [_vm._v("Charlotte said sarcastically, folding her legs under her and opening her textbook.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why wouldn’t you give it a go, Charlotte? Life is all about collecting experiences, and this seems like a pretty exciting one. I’d do it in a second if someone ever gave me the chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ll tell you the time and place. You can go in my stead. How will they know you’re not Charlotte Friedman reporting for duty? Model duty.” Charlotte giggled.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Have you looked at me lately?” JoJo asked, tilting her head.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I have. I look at you all the time, and each and every time I do, I see a beautiful young woman with dazzling chestnut-brown hair, the cutest nose this side of the East River, and hazel eyes that burn with a zest for life and the confidence to take on the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“That was so nice,” JoJo whimpered, pretending to wipe a tear from her eye.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte threw a pillow at her head and laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Opportunities come when you least expect them, Charlotte.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Are you trying to say that there’s an opportunity for me in modeling, and I just have to report to John Robert Powers on Monday, where my true destiny will be revealed?” Charlotte held out her hands, pretending to look into a crystal ball.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Would that be the worst thing?” JoJo asked, lifting her left brow.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Perhaps.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I hope you know I say this out of love, but it’s not like you have job opportunities knocking down your front door. I "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_26",
      "title": "26"
    }
  }, [_vm._v("know tons of girls, including myself, who would do anything to be Miss Subways.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte sat against the headboard and thought for a moment about what JoJo was telling her. “How nice for them,” she said. “It’s time to study.”")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("Sam was waiting at their regular corner table in the back of Thompson’s Drugstore and he waved Charlotte over. Immediately her shoulders softened and a smile came to her face.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sweet, stable, reliable Sam. Tall, reddish-haired, sparkling blue-eyed Sam. The pair were set up by a mutual friend during Charlotte’s freshman year of college, when Sam was home from law school over winter break. That was nearly four years ago, and they’d been going together ever since. Sam worked at Linden & Linden in Midtown. His hours were decidedly horrendous, required for future partners of important Manhattan law firms. But trying for courting. And though Charlotte knew Sam wished he had more time for their relationship, wished that his face didn’t look so gray due to lack of sunlight and sleep, she also knew that his career was important to him and she found that a redeeming quality. One on a list of many.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Darling,” he said as he rose to give her a kiss on the cheek. He pulled out her chair and she plopped down. Drained. Sighing. “What is it, Charlotte?” Sam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I heard from J. Walter Thompson.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And?” Sam asked expectantly.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“They don’t want me either. Nobody wants me, Sam.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Oh, Charlotte, honey. I’m so sorry. And you know that’s "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_27",
      "title": "27"
    }
  }, [_vm._v("not true. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I")]), _vm._v(" want you. In fact, I wish you’d reconsider my proposal,” Sam said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sam, you know I don’t want to get married yet. I have so many things I want to do. Besides, how would that change anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We can elope. The sooner the better. And then you’d feel less of an urgency to start a job right away because I’d have you out of your parents’ house.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sam,” Charlotte said, tilting her head.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What’s so awful about marrying a guy like me, anyway?” Sam asked as he took a sip of his Coke.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We’ve been through this a million times. There’s not one itty-bitty, tiny, little thing wrong with marrying a guy like you. In fact, there are a trillion things right with marrying a guy like you, and someday it will happen. Just not now. I’m only twenty-one. There’s time.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“But I’m twenty-six. I think the older partners think there’s something wrong with me that I’m not married, and when it’s time for me to be up for partner, I don’t want them to overlook me because they think I’m not a family man.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well, you tell those hoity-toity partners that your future wife is making a name for herself. They’ll put you right at the top of that partners list knowing you snagged a girl who had something going for her.” Charlotte lifted her chin and smirked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Okay, okay, Miss Confident. I’ll call a meeting first thing Monday morning to announce to all who will listen that I have the smartest, most ambitious girl in all of New York City, and that if they don’t make a partner of me, I’ll open my own firm and sue ’em all.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Now that’s more like it,” Charlotte said, and squeezed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_28",
      "title": "28"
    }
  }, [_vm._v("Sam’s hand. “But what will they think when you’re not a family man in the traditional sense of the word?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sorry about that, Charlotte. I wasn’t thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s okay. I guess I’ve kind of gotten used to it. But I still can’t believe you’d be okay with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“My first choice is you. If we can’t have children together, then that’ll just be how it has to be. Or we can adopt. Either way, I love you, Charlotte. You know that. Babies or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I love you too. And thanks for saying that.” They stared into each other’s eyes. Perry Como swooning, seemingly just for them, in the background.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte did want to marry Sam. Just not yet. She had told him that the first time he had proposed during the summer after Charlotte’s freshman year of college. There was no ring, of course; she was only eighteen. Not like girls at eighteen didn’t get rings from their boyfriends. But Sam told Charlotte he knew she had plans. He told her he wanted to make sure she knew he was serious about her. That he had his own plans and they included her. He had proposed a few times since, always sincerely but never entirely seriously because indeed there was no ring. Charlotte knew that when a man was truly serious about proposing, there was a ring. And a bent knee. And that’s what she would have. With Sam. Someday, when the timing was absolutely right.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What am I going to do about a job?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“J. Walter Thompson isn’t the only game in town. Why don’t you send letters to some of the other concerns?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ve thought of that. I even called J. Walter Thompson and told them they were making a grave mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sam smiled, reaching for Charlotte’s hands over the table and enclosing them in his own. “You’re such a go-getter.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_29",
      "title": "29"
    }
  }, [_vm._v("“That’s what the JWT man said. But look how far that go-getting got me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Something will turn up. Any one of these agencies would be lucky to have a girl like you working at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You think? Why?” Charlotte asked coyly.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sam saw the bait clearly and took it anyway. “Well, you’re the most beautiful girl in all of New York City, and you know how those account men like to stock their lakes with the pretty ones. You’re the smartest girl I know. And I’ve seen you type. Boy, do those fingers dance.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte smiled dejectedly.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The waiter delivered their food, the grilled cheese glistening and the perfect shade of golden brown that Charlotte liked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“When is your graduation ceremony?” Sam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“June twenty-second.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You have three months to find something. That’s plenty of time, Charlotte.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte took a bite of her sandwich and, a thought occurring to her, looked up at Sam. “What would you think if I became a model?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“A model?” Sam exclaimed. “I’d support you in anything you chose to do, but I never knew you were interested in modeling.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Remember the night Martin suggested entering me into Miss Subways? I got a letter today saying I’m a finalist.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sam slammed his Coke down on the table harder than he had intended. Enough so that the couples nearby broke their necks looking. “That’s terrific!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You really think so?” Charlotte couldn’t imagine Sam would take Miss Subways seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sure I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_30",
      "title": "30"
    }
  }, [_vm._v("“JoJo thought so too, but I don’t know. It seems so ‘look at me, look at me.’ And it certainly promotes celebrating a girl’s looks instead of her talents.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t think you need to dissect it so conscientiously. Seems like the girls in those pictures are having a lot of fun. Go for it, Charlotte. I’d love to tell the guys at work that my girl is Miss Subways.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte laughed and leaned over to give Sam a kiss. She appreciated his enthusiasm, but something about it still didn’t feel right.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("In bed that night, Charlotte couldn’t stop thinking about what Sam and JoJo had said. Why wouldn’t she go to John Robert Powers? Just for the experience, at least. If life, as JoJo claimed, was all about collecting experiences, then she didn’t yet have a life worth bragging about, her most exciting experience to date having been a full day at the 1939 New York World’s Fair when she was eleven.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("At the time, and for several years after, Charlotte thought that nothing would ever compare to the terrifying parachute jump, the synchronized swimming show (that Johnny Weissmuller!), and especially those darling monkeys. She’d thought there would never be anything in life more thrilling.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She and Harry had talked about that day for years. And each time, their memories made the shiny shinier. Charlotte was even more terrified of the parachute jump, and Harry, of course, was even braver. Harry was even more certain he would grow taller and swim faster than Johnny Weissmuller. (Perhaps, Charlotte would say, but she’d insist he’d never be as handsome.) And Charlotte was even more smitten with Monkey Mountain and its hundreds of inhabitants. They’d "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_31",
      "title": "31"
    }
  }, [_vm._v("spent hours re-creating the spectacles in their living room on cold winter days, forcing their parents to sit in the audience. Their father, without fail, would leave their show before it was over.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But memories fade. And those, despite their impact, had faded like the photo of her brother in its frame on the mantel. Perhaps it was time for a new experience.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Charlotte tiptoed down the stairs and felt her way into the dark kitchen. Opening the garbage can, she sifted through the scraps and eventually found what she was looking for. Smoothing out the paper, which luckily had somehow been protected from the dregs of dinner, Charlotte reread its contents. She still had a few days to make her decision, and figured she’d sleep on it. But after scrutinizing the letter more carefully, with its self-important tone and affected presentation—undoubtedly an extension of the John Robert Powers models themselves, Powers Girls, as they were pretentiously called—she scoffed and tossed it back where it belonged.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 84
// module chunks = 0